import { createAction, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDashboardSlice, IContactUs } from "./types";
import { RequestStatus } from "@app/constants";
import { IRequestFailed } from "@app/types";

const initialState: IDashboardSlice = {
  dashboard: {},
  nonParentCategories: {},
};

const slice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    dashboard(state, action: PayloadAction) {
      state.dashboard.status = RequestStatus.RUNNING;
    },
    dashboardSuccess(state, action) {
      state.dashboard.status = RequestStatus.SUCCESS;
      state.dashboard.data = action.payload;
    },
    dashboardFailed(state, action: PayloadAction<IRequestFailed>) {
      state.dashboard.status = RequestStatus.ERROR;
      state.dashboard.error = action.payload;
    },
    nonParentCategories(state, action: PayloadAction) {
      state.nonParentCategories.status = RequestStatus.RUNNING;
    },
    nonParentCategoriesSuccess(state, action) {
      state.nonParentCategories.status = RequestStatus.SUCCESS;
      state.nonParentCategories.data = action.payload;
    },
    nonParentCategoriesFailed(state, action: PayloadAction<IRequestFailed>) {
      state.nonParentCategories.status = RequestStatus.ERROR;
      state.nonParentCategories.error = action.payload;
    },
  },
});

export const {
  dashboard,
  dashboardSuccess,
  dashboardFailed,
  nonParentCategories,
  nonParentCategoriesSuccess,
  nonParentCategoriesFailed,
} = slice.actions;

export default slice.reducer;

